import { getColorForValue } from './colors';

/**
 * Renders a value from a finite/enumerable column (e.g. Prompt Type, Prompt ID)
 * as a colored badge so the same value is always easy to spot at a glance.
 */
function ValueBadge({ value }) {
  if (value === null || value === undefined || value === '') return '—';
  const color = getColorForValue(value);
  return <span className="sense-shield-pill" style={{ background: color }}>{value}</span>;
}

export default ValueBadge;
